import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import useFunctions from '../../Hooks/useFunctions';

export default function Button({ btnText, btnUrl, variantColor }) {

  const{scrollToSection} = useFunctions();
  
  return (
    <Link
      to={btnUrl}
      className={`cs_btn cs_style_1 `}
      style={{color:"#000000"}}
      onClick={() => scrollToSection("contact")}
    >
      {btnText}
      <span>
        <i>
          <Icon icon="fa6-solid:arrow-right"      style={{color:"#000000"}}/>
        </i>
        <i>
          <Icon icon="fa6-solid:arrow-right"      style={{color:"#000000"}}/>
        </i>
      </span>
    </Link>
  );
}
